document.querySelectorAll('.template--product [data-add-btn]').forEach(btn => {
  btn.addEventListener('click', (event) => {
    event.preventDefault();
    const targetButton = document.querySelector('.form__btns .add-to-cart-btn');
    if (targetButton) {
      targetButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
      targetButton.click();
    }
  });
});